import {
  DashboardTypes,
  DeleteStoredQueryMutation,
  DeleteStoredQueryMutationVariables,
  GetCustomValueHistoryQuery,
  GetStoredQueryQuery,
  GetStoredQueryQueryVariables,
  SaveCustomValueMutation,
  SaveCustomValueMutationVariables,
  UserQuery,
} from 'API';
import { a, API } from 'aws-amplify';
import { deleteStoredQuery, saveCustomValue } from 'graphql/mutations';
import { getCustomValueHistory, getStoredQuery } from 'graphql/queries';
import { KPIvalues } from '../CustomReportKPI';
import APIContext from 'context/APIContext';
import { useContext } from 'react';
import { getFilesFromS3 } from 'components/NewPortal/Main/Brief/UploadFile/getFilesfromS3';
import { useCustomReportContext } from 'context/CustomReportContext';

export const useGetStoredFile = (): readonly [(position: string) => Promise<File>] => {
  const { activeCustomReport } = useCustomReportContext();
  const { getEnvironment } = useContext(APIContext);
  const fetchStoredFile = async (position: string) => {
    try {
      const response = (await API.graphql({
        query: getStoredQuery,
        variables: {
          campaign_id: activeCustomReport?.CustomReportID.toString(),
          position: position,
        } as GetStoredQueryQueryVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetStoredQueryQuery };
      const responseID = response.data.getStoredQuery;

      const file = await getFilesFromS3(
        responseID as UserQuery,
        activeCustomReport?.Client?.Code as string,
        activeCustomReport?.Client?.Country as string,
        // activeCampaign?.ClientCode as string,
        // activeCampaign?.ClientCountry as string,
        getEnvironment,
      );

      // if (file) {
      //   setSelectedFile(file);
      // }

      return file as File;
    } catch (e) {
      console.log(`ERROR WAS THIS: ${e}`);
      return {} as File;
    }
  };
  return [fetchStoredFile];
};

export const useRemoveFileFromS3 = (): readonly [(position: string) => Promise<boolean>] => {
  const { getEnvironment } = useContext(APIContext);
  const { activeCustomReport } = useCustomReportContext();
  const removeFileFromS3 = async (position: string) => {
    try {
      const deleteStoredQ = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeCustomReport?.CustomReportID.toString(),
          placeholder: position,
          Environment: getEnvironment,
        } as DeleteStoredQueryMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
      const res = deleteStoredQ.data.deleteStoredQuery;
      if (res?.StatusCode === 200) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(`ERROR WAS THIS: ${e}`);
      return false;
    }
  };
  return [removeFileFromS3];
};
